import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { environment } from '../../environments/environment';
import { firestore } from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class CandidateService {

  candidateData;
  baseUrl;

  constructor(private http: HttpClient, private auth: AuthService, private afs: AngularFirestore) {
    if (environment.production) {
      this.baseUrl = ''
    } else {
      this.baseUrl = 'http://localhost:5000'
    }
  }

  getJobRoles(jobType){
    return this.afs.collection('job-roles',ref => ref.where('job-type', '==', jobType)).valueChanges()
  }

  getJobTypes(){
    console.log(this.afs.collection('job-types').valueChanges())
    return this.afs.collection('job-types').valueChanges();
  }

  setCandidateDetails(data) {
    return this.http.post(`${this.baseUrl}/api/updateCandidate`, data, { responseType: 'json' });
  }

  updateSkills(data) {
    return this.afs.collection('skills').doc('skills').update({"skills":firestore.FieldValue.arrayUnion(data)})
    //return this.http.post('/api/updateSkills', data, { responseType: 'text' });
  }

  getSkills() {
    return this.afs.collection('skills').doc('skills').valueChanges()
    //return this.http.get('/api/getSkills');
  }

  getPreferenceLocations(){
    return this.afs.collection('locations').doc('locations').valueChanges()
  }

  updatePreferenceLocations(data) {
    return this.afs.collection('locations').doc('locations').update({"locations":firestore.FieldValue.arrayUnion(data)})
    //return this.http.post('/api/updateSkills', data, { responseType: 'text' });
  }

  getLocations(input) {
    let proxyUrl = 'https://cors-anywhere.herokuapp.com/';
    return this.http.get(`${proxyUrl}https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${input}&key=AIzaSyDEqWPsLUkNV3Ut3KfELN7HPo8stdpV8lE&sessiontoken=1234567890`)
  }

  getCandidateDetails(id) {
    return this.http.post(`${this.baseUrl}/api/getCandidate`, { _id: id })
  }
}

